import React, { useState, useEffect } from "react";
import FriendRequests from "../components/FriendRequests";
import FriendsList from "../components/FriendsList";
import { FriendContext } from "../helpers/FriendContext";
import axios from "axios";
import GamesStatus from "../components/GamesStatus";

function Friends() {
  const [friends, setFriends] = useState([]);
  const username = localStorage.getItem("username");

  useEffect(() => {
    axios
      .get("https://verbalvortex-server.onrender.com/friends/accepted", {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        setFriends(response.data);
      })
      .catch((error) => {
        console.error("Error fetching friends:", error);
      });
  }, [username]);

  return (
    <div className="Friends">
      <FriendContext.Provider value={{ friends, setFriends }}>
        <FriendRequests />
        <FriendsList />
      </FriendContext.Provider>
      <GamesStatus />
    </div>
  );
}

export default Friends;
